import { Spinner } from '@blueprintjs/core'
import React from 'react'

import '../styles/animations.css'


export default ({ className, ...rest }) => (
  <Spinner className={`bai-fade-in`} {...rest} />
)
